import { Divider } from '@mui/material';
import { DocumentStatus } from '@synergy/models';
import { EditIcon, EyeIcon, TrashIcon } from '@synergy/theme';
import { FormattedMessage } from 'react-intl';
import { MailForwardIcon } from '@synergy/theme-next';
import { PoolMenu, PoolMenuItem } from '@synergy/components';
import { PoolTooltip } from '@synergy/components-next';

import { DemandAccountStatus } from '../../../../../models/demand-account-status';

interface DemandDetailFeedbackActionMenuProps {
    readonly: boolean;
    demandStatus: DocumentStatus;
    demandAccountStatus: DemandAccountStatus;
    onSendInfoMail?: () => void;
    onEditFeedback?: () => void;
    onDeclineFeedback?: () => void;
}

export const DemandDetailFeedbackActionMenu = (props: DemandDetailFeedbackActionMenuProps) => {
    const sendInfoMailMenuItemDisabled = ![
        DemandAccountStatus.Accepted,
        DemandAccountStatus.PartiallyAccepted,
    ].includes(props.demandAccountStatus);
    const sendInfoMailMenuItem = (
        <PoolMenuItem
            disabled={sendInfoMailMenuItemDisabled}
            isExtendedMenu={true}
            icon={<MailForwardIcon />}
            title="app.demands.detail.feedback.sendInfoMail"
            onClick={props.onSendInfoMail}
        />
    );

    return (
        <PoolMenu menuPosition="right">
            {props.readonly && (
                <PoolMenuItem
                    isExtendedMenu={true}
                    icon={<EyeIcon />}
                    title="app.demands.detail.feedback.showDetails"
                    onClick={props.onEditFeedback}
                />
            )}
            {!props.readonly && (
                <PoolMenuItem
                    isExtendedMenu={true}
                    icon={<EditIcon />}
                    title="app.demands.detail.feedback.editDetails"
                    onClick={props.onEditFeedback}
                />
            )}

            {[DocumentStatus.Ongoing, DocumentStatus.Completed].includes(props.demandStatus) && (
                <>
                    <Divider />
                    {sendInfoMailMenuItemDisabled ? (
                        <PoolTooltip
                            title={<FormattedMessage id="app.demands.detail.feedback.sendInfoMail.disabledTooltip" />}
                        >
                            {sendInfoMailMenuItem}
                        </PoolTooltip>
                    ) : (
                        sendInfoMailMenuItem
                    )}
                </>
            )}
            {!props.readonly && (
                <>
                    <Divider />
                    <PoolMenuItem
                        isExtendedMenu={true}
                        icon={<TrashIcon />}
                        title="app.demands.detail.feedback.decline"
                        onClick={props.onDeclineFeedback}
                    />
                </>
            )}
        </PoolMenu>
    );
};
